import React, { useState, useEffect } from "react";
import bannerImg from "../banner/banneri.png";
import {
  conferenceInfo,
  carouselImages,
  notices,
  convenor,
  coConvenors,
  contactInfo,
} from "../data/mockData";
import { ChevronLeft, ChevronRight, Download } from "lucide-react";

const partnerLogos = [
  "/images/logos/logo1.jpg",
  "/images/logos/logo2.jpg",
  "/images/logos/logo3.jpg",
  "/images/logos/logo4.jpg",
  "/images/logos/logo5.jpg",
  "/images/logos/logo6.jpg",
];

const carouselCaptions = [
  {
    index: 1,
    subtitle: "Integral University",
    title: "Full Campus View",
  },
  {
    index: 2,
    subtitle: "Integral University",
    title: "Department of Civil Engineering",
  },
  {
    index: 3,
    subtitle: "Integral University",
    title: "Central Auditorium",
  },
  {
    index: 4,
    subtitle: "Integral University",
    title: "Academic Block I",
  },
  {
    index: 5,
    subtitle: "Integral University",
    title: "Phase III",
  },
  {
    index: 6,
    subtitle: "Integral University",
    title: "University Ground",
  },
  {
    index: 7,
    subtitle: "Integral University",
    title: "Boys Hostel",
  },
  {
    index: 8,
    subtitle: "Integral University",
    title: "Block A, Phase III",
  },
];

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const nextSlide = () =>
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);

  const prevSlide = () =>
    setCurrentSlide(
      (prev) => (prev - 1 + carouselImages.length) % carouselImages.length,
    );

  const handleNoticeClick = (pdfUrl) => window.open(pdfUrl, "_blank");

  return (
    <div className="mt-5">
      {/* Partner logos */}
      <section className=" bg-gradient-to-br from-black/85 via-black/100 to-black/85 py-8 sm:py-7">
        <h2 className="relative z-10 mb-4 block text-center text-base font-bold tracking-widest text-white sm:text-xl">
          OUR PARTNERS
        </h2>

        <div className="mx-auto grid max-w-6xl grid-cols-3 items-center justify-items-center gap-2 px-2 sm:gap-4 md:grid-cols-6 md:gap-5">
          {partnerLogos.map((logo, index) => (
            <div
              key={logo}
              className="flex h-16 w-full max-w-24 items-center justify-center rounded-lg border border-gray-200 bg-white p-2 shadow-sm transition-transform duration-300 hover:scale-105 sm:h-20 sm:max-w-36 sm:p-3 md:h-24 md:max-w-40"
            >
              <img
                src={logo}
                alt={`Conference partner ${index + 1}`}
                className="block max-h-full max-w-full object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </section>

      {/* Hero */}
      <div
        className="relative flex min-h-screen items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `url(${bannerImg})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/70 to-black/80" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.25),transparent_40%),radial-gradient(circle_at_80%_30%,rgba(59,130,246,0.35),transparent_40%)]" />

        <div className="relative z-10 mx-auto max-w-5xl px-3 text-center">
          <span className="mb-4 inline-block rounded-full bg-white/25 px-6 py-2 font-semibold tracking-widest text-white shadow-lg backdrop-blur-md">
            TG-SMART 2026
          </span>

          <h1 className="mb-14 text-3xl font-extrabold text-white drop-shadow-[0_4px_12px_rgba(0,0,0,0.9)] md:text-5xl lg:text-6xl">
            {conferenceInfo.title}
          </h1>

          <div className="rounded-3xl border border-white/20 bg-black/1 px-4 py-10 shadow-2xl backdrop-blur-md">
            <h2 className="mb-4 text-lg font-medium text-gray-100 drop-shadow-md md:text-xl">
              {conferenceInfo.subtitle}
            </h2>

            <h3 className="my-6 text-2xl font-bold text-red-400 drop-shadow-lg md:text-4xl">
              {conferenceInfo.shortName}
            </h3>

            <p className="mb-3 text-xl font-semibold text-white drop-shadow-md">
              {conferenceInfo.dates}
            </p>
          </div>
        </div>
      </div>

      {/* Campus Gallery */}
      <div id="gallery" className="relative overflow-hidden bg-slate-50 py-15">
        <div className="absolute inset-0 bg-[radial-gradient(#94a3b8_1px,transparent_1px)] bg-[size:24px_24px] opacity-[0.25]" />

        <div className="relative bg-[radial-gradient(circle_at_15%_25%,rgba(59,130,246,0.22),transparent_32%),radial-gradient(circle_at_85%_20%,rgba(167,139,250,0.18),transparent_32%),radial-gradient(circle_at_50%_80%,rgba(134,239,172,0.18),transparent_35%)] py-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6">
            <h2 className="mb-2 text-center text-3xl font-bold text-gray-800 sm:text-4xl">
              Campus Gallery
            </h2>
            <div className="mx-auto mb-10 h-1 w-32 bg-primary-600" />

            {/* Main slider */}
            <div className="group relative mb-2 h-[300px] overflow-hidden rounded-3xl shadow-[0_25px_80px_rgba(0,0,0,0.25)] sm:h-[520px]">
              {carouselImages.map((image, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-all duration-1000 ${
                    index === currentSlide
                      ? "scale-100 opacity-100"
                      : "scale-110 opacity-0"
                  }`}
                >
                  <img
                    src={image}
                    alt={`Campus ${index + 1}`}
                    className="h-full w-full object-cover"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

                  <div className="absolute bottom-10 left-10 text-white">
                    <p className="text-sm uppercase tracking-widest opacity-80">
                      {carouselCaptions[index]?.subtitle ||
                        "Integral University"}
                    </p>
                    <h3 className="text-2xl font-bold md:text-4xl">
                      {carouselCaptions[index]?.title ||
                        `Campus View ${index + 1}`}
                    </h3>
                  </div>
                </div>
              ))}

              <button
                onClick={prevSlide}
                aria-label="Previous slide"
                className="absolute left-6 top-1/2 z-20 -translate-y-1/2 rounded-full bg-white/20 p-4 text-white opacity-0 shadow-xl backdrop-blur-md transition hover:bg-white hover:text-black group-hover:opacity-100"
              >
                <ChevronLeft size={32} />
              </button>

              <button
                onClick={nextSlide}
                aria-label="Next slide"
                className="absolute right-6 top-1/2 z-20 -translate-y-1/2 rounded-full bg-white/20 p-4 text-white opacity-0 shadow-xl backdrop-blur-md transition hover:bg-white hover:text-black group-hover:opacity-100"
              >
                <ChevronRight size={32} />
              </button>

              <div className="absolute bottom-5 left-1/2 flex -translate-x-1/2 gap-3">
                {carouselImages.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    aria-label={`Go to slide ${index + 1}`}
                    className={`transition-all duration-300 ${
                      index === currentSlide
                        ? "h-3 w-10 rounded-full bg-white"
                        : "h-3 w-3 rounded-full bg-white/60 hover:bg-white"
                    }`}
                  />
                ))}
              </div>
            </div>

            {/* Thumbnail strip */}
            <div className="mt-6 flex justify-center gap-4 overflow-x-auto pb-2">
              {carouselImages.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Campus thumbnail ${index + 1}`}
                  onClick={() => setCurrentSlide(index)}
                  className={`h-20 w-32 cursor-pointer rounded-xl object-cover transition-all duration-300 ${
                    currentSlide === index
                      ? "scale-105 ring-4 ring-primary-600"
                      : "opacity-60 hover:opacity-100"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Map and notices */}
      <section className="relative overflow-hidden py-20">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100" />
        <div className="absolute left-[-120px] top-[-120px] h-[420px] w-[420px] rounded-full bg-primary-300 opacity-30 blur-[140px]" />
        <div className="absolute bottom-[-120px] right-[-120px] h-[420px] w-[420px] rounded-full bg-indigo-300 opacity-30 blur-[140px]" />
        <div className="absolute left-[40%] top-[40%] h-[320px] w-[320px] rounded-full bg-sky-200 opacity-30 blur-[120px]" />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
          <div className="mb-5 text-center">
            <h2 className="text-3xl font-bold text-gray-800 sm:text-4xl">
              Venue &amp; Announcements
            </h2>
            <div className="mx-auto mt-4 h-1 w-32 bg-primary-600" />
            <p className="mx-auto mt-4 max-w-2xl text-gray-600">
              Find us on the map and stay updated with the latest conference
              notices.
            </p>
          </div>

          <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-5">
            {/* Map card */}
            <div className="group lg:col-span-3">
              <div className="rounded-3xl border border-white bg-white/70 p-6 shadow-[0_20px_70px_rgba(0,0,0,0.15)] backdrop-blur-lg transition-all duration-500 group-hover:shadow-[0_25px_90px_rgba(0,0,0,0.25)]">
                <h3 className="mb-2 text-2xl font-bold text-gray-800">
                  Venue Location
                </h3>
                <div className="mb-6 h-1 w-20 bg-primary-600" />

                <div className="overflow-hidden rounded-2xl border-4 border-white shadow-xl">
                  <iframe
                    title="Integral University Location"
                    src={contactInfo.mapUrl}
                    width="100%"
                    height="420"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                  />
                </div>

                <p className="mt-4 text-sm text-gray-600">
                  Integral University, Lucknow — Conference Venue
                </p>
              </div>
            </div>

            {/* Notices card */}
            {/* Notices card */}
            <div className="group min-w-0 lg:col-span-2">
              <div className="relative h-[520px] min-w-0 overflow-hidden rounded-3xl border border-white bg-white/70 p-6 shadow-[0_20px_70px_rgba(0,0,0,0.15)] backdrop-blur-lg">
                <h3 className="mb-2 text-2xl font-bold text-gray-800">
                  Latest Notices
                </h3>
                <div className="mb-6 h-1 w-20 bg-primary-600" />

                <div className="absolute inset-x-6 bottom-6 top-24 min-w-0 overflow-hidden">
                  <div className="notice-scroll-track flex w-full flex-col">
                    {[0, 1].map((copy) => (
                      <div
                        key={copy}
                        className="flex shrink-0 flex-col gap-4 pb-4"
                        aria-hidden={copy === 1}
                      >
                        {notices.map((notice, index) => (
                          <div
                            key={`${copy}-${index}`}
                            onClick={() => handleNoticeClick(notice.pdfUrl)}
                            className="w-full min-w-0 cursor-pointer rounded-xl border-l-4 border-primary-600 bg-gradient-to-r from-primary-100 to-indigo-100 p-4 shadow-md transition hover:shadow-xl"
                          >
                            <div className="flex min-w-0 items-start justify-between gap-3">
                              <div className="min-w-0 flex-1">
                                <p className="mb-1 text-xs font-semibold text-primary-700">
                                  {notice.date}
                                </p>
                                <p className="break-words text-sm text-gray-700">
                                  {notice.text}
                                </p>
                              </div>

                              <Download
                                size={18}
                                className="shrink-0 text-primary-600"
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Message from Convenor */}
      <section className="bg-[radial-gradient(circle_at_15%_25%,rgba(59,130,246,0.22),transparent_32%),radial-gradient(circle_at_85%_20%,rgba(167,139,250,0.18),transparent_32%),radial-gradient(circle_at_50%_80%,rgba(134,239,172,0.18),transparent_35%)] py-12">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <h2 className="mb-2 text-center text-3xl font-bold text-gray-800 sm:text-4xl">
            Message from the Convenor
          </h2>
          <div className="mx-auto mb-8 h-1 w-32 bg-primary-600" />

          <div className="rounded-xl border-t-4 border-primary-600 bg-primary-100 p-8 shadow-2xl">
            <div className="flex flex-col items-center gap-6 md:flex-row md:items-start">
              <a
                href={convenor.linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={convenor.image}
                  alt={convenor.name}
                  className="h-60 w-60 rounded-full border-4 border-primary-600 object-cover shadow-xl transition-transform hover:scale-105"
                />
              </a>

              <div className="flex-1 text-center md:text-left">
                <a
                  href={convenor.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mb-2 text-2xl font-bold text-gray-800 transition-colors hover:text-primary-700 hover:underline"
                >
                  {convenor.name}
                </a>

                <p className="mb-1 font-semibold text-primary-700">
                  {convenor.designation}
                </p>
                <p className="mb-4 text-gray-600">{convenor.organization}</p>
                <p className="text-base italic leading-relaxed text-gray-700">
                  &ldquo;{convenor.message}&rdquo;
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Messages from Co-Convenors */}
      <section className="bg-primary-100 py-12">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h2 className="mb-2 text-center text-3xl font-bold text-gray-800 sm:text-4xl">
            Messages from Co-Convenors
          </h2>
          <div className="mx-auto mb-8 h-1 w-32 bg-primary-600" />

          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {coConvenors.map((coConvenor) => (
              <div
                key={coConvenor.id}
                className="rounded-xl border-t-4 border-primary-600 bg-white p-6 shadow-xl transition-shadow hover:shadow-2xl"
              >
                <a
                  href={coConvenor.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <img
                    src={coConvenor.image}
                    alt={coConvenor.name}
                    className="mx-auto mb-4 h-32 w-32 rounded-full border-4 border-primary-500 object-cover shadow-lg transition-transform hover:scale-105"
                  />
                </a>

                <a
                  href={coConvenor.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mb-2 block text-center text-xl font-bold text-gray-800 transition-colors hover:text-primary-700 hover:underline"
                >
                  {coConvenor.name}
                </a>

                <p className="mb-1 text-center text-sm font-semibold text-primary-700">
                  {coConvenor.designation}
                </p>
                <p className="mb-4 text-center text-sm text-gray-600">
                  {coConvenor.organization}
                </p>
                <p className="text-center text-sm italic leading-relaxed text-gray-700">
                  &ldquo;{coConvenor.message}&rdquo;
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
